import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { AlertTriangle } from 'lucide-react';
import { computeLineItemMismatchWarnings } from '../../utils/poMismatch';

// Shared PO Line Item picker + live advisory mismatch warning — used on Session,
// Partner Conference and Regional In-Person delivery forms once a PO is selected.
export const POLineItemSelect = ({ pos = [], poNumber, lineItemId, deliveryType, deliveryDate, invoiceAmount, onChange, testIdPrefix = 'po-line-item' }) => {
  const selectedPo = pos.find(p => p.po_number === poNumber);
  const lineItems = selectedPo?.line_items || [];
  if (!poNumber || lineItems.length === 0) return null;

  const selectedLineItem = lineItems.find(li => li.id === lineItemId);
  const warnings = selectedLineItem
    ? computeLineItemMismatchWarnings(selectedLineItem, deliveryType, deliveryDate, invoiceAmount)
    : [];

  return (
    <div className="space-y-1.5" data-testid={`${testIdPrefix}-wrapper`}>
      <Label className="text-xs">PO Line Item (optional)</Label>
      <Select
        value={lineItemId || '__none__'}
        onValueChange={(v) => {
          if (v === '__none__') { onChange(null, null); return; }
          const li = lineItems.find(l => l.id === v);
          onChange(v, li?.description || '');
        }}
      >
        <SelectTrigger data-testid={`${testIdPrefix}-select`}>
          <SelectValue placeholder="Link to a specific PO line item..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__">No specific line item</SelectItem>
          {lineItems.map(li => (
            <SelectItem key={li.id} value={li.id}>
              {li.description}{li.delivery_date ? ` — ${li.delivery_date}` : ''} (${(li.amount || 0).toLocaleString()})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {warnings.length > 0 && (
        <div className="rounded-lg border border-amber-300 bg-amber-50 p-2.5 space-y-1" data-testid={`${testIdPrefix}-mismatch-warning`}>
          {warnings.map((w, i) => (
            <p key={i} className="text-xs text-amber-800 flex items-start gap-1.5">
              <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
              {w}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default POLineItemSelect;
